import React from 'react';

export default function BranchesMaintenance() {
  return <div>BranchesMaintenance</div>;
}
